import { merge } from "lodash";

import { LISTING_STATUS_CODE } from "../../../components/common/const";
import {
  BULK_ACTIONS,
  OTHER_ACTIONS,
  SINGLE_ACTIONS,
} from "../../../components/component-listings/consts";

import common from "./common";

export default merge(common, {
  search: {
    placeholder:
      "Search by township, postcode, state, city, building name, street, address, ID or listing reference number",
    mobile: {
      placeholder: "Search listings",
    },
    internalStaff: {
      placeholder: "Search by Listing ID",
    },
    searchBy: {
      title: "Find the right listing by searching for...",
      text: "Search by Township, postcode, state, city, building name, street, address, ID or listing reference number.",
    },
    location: {
      level1: "State",
      level2: "City",
      level3: "Township",
      level5: "Building",
    },
  },
  filters: {
    sort: {
      title: "Sort by",
      "new-to-old":
        "{listingStatus, plural, =1 {Created} =2 {Listed} =3 {Offline} =5 {Expired} other {}} (New to old)",
      "old-to-new":
        "{listingStatus, plural, =1 {Created} =2 {Listed} =3 {Offline} =5 {Expired} other {}} (Old to new)",
      "high-to-low": "Price (High to low)",
      "low-to-high": "Price (Low to high)",
      "new-to-old-posted-date": "Posted (New to old)",
      "old-to-new-posted-date": "Posted (Old to new)",
      "old-to-new-expiry-date": "Listing expiry date",
      "new-to-old-expiry-date": "Listing expiry date",
      "product-expiry-date": "Upgrade expiry date",
    },
  },
  listingList: {
    title: "Listings",
    propertyItem: {
      image: {
        alt: "Cover Image",
      },
      basicInfo: {
        price: `{unit} {price}`,
        landArea: "Land area: <strong>{value}</strong>",
        builtArea: "Built-up: <strong>{value}</strong>",
      },
      buttons: {
        overview: "Overview",
        reporting: "Reporting",
        leads: "Leads",
        edit: "Edit",
        delete: "Delete",
        duplicate: "Copy",
        upgrade: "Upgrade",
        readvertise: "Readvertise",
        reactivate: "Reactivate",
        reactivating: "Reactivating...",
      },
      tierDate: {
        visibility: "Visibility: <strong>{value}</strong>",
      },
      basicDate: {
        posted: "Posted",
        visibility: "Visibility: <strong>--</strong>",
      },
      auctionDateLabel: "Auction",
      more: {
        extend: "Extend listing expiry",
        offline: "Take offline",
        cancelAutoUpgrade: "Cancel auto-upgrade",
      },
    },
    auction: "Auction",
    message: {
      success: {
        upgrade: "This listing has been successfully upgraded.",
        reactivate: "Successfully made this listing online.",
        delete: "Your listing has been deleted.",
      },
      error: {
        delete: "Deleting was unsuccessful.",
        duplicate: "Duplicating was unsuccessful",
        reactivate: "Reactivating was unsuccessful",
        view_degraded:
          "You have {count} listing{count, plural, =0 {} =1 {} other{s}} that have been degraded.",
      },
      link: {
        success: "View success listings",
        error: "View failed listings",
        schedule: {
          success: "View schedule manager",
        },
        view_degraded: {
          error: "View listings",
        },
      },
    },
    tooltip: {
      posted: "The date the listing moves to the top of the tier.",
      listed: {
        [LISTING_STATUS_CODE.ONLINE]:
          "The most recent date the listing went online.",
        [LISTING_STATUS_CODE.DRAFT]:
          "The actual date this listing was created.",
        [LISTING_STATUS_CODE.EXPIRED]: "The date the listing expires.",
        [LISTING_STATUS_CODE.OFFLINE]:
          "The most recent date the listing was switched to offline.",
      },
      auction: "auction tooltip content",
    },
  },
  listingListView: {
    expiry: "Expiry:",
    headers: {
      tierChannelId: "Tier, Type, ID",
      buildingAddress: "Building - Address",
      propertyType: "Property type",
      price: "Price",
      builtUp: "Built-up",
      landArea: "Land area",
      posted: "Posted",
      listingExpiry: "Listing expiry",
      visibility: "Visibility",
      created: "Created",
      offline: "Offline",
      expired: "Expired",
    },
  },
  buttons: {
    addProperty: "Create listing",
    bulkActions: {
      main: "More actions",
      readvertise: "Readvertise listings",
      schedule: "Schedule Readvertisement",
      offline: "Take listings offline",
      delete: "Delete listings",
      reactivate: "Reactivate",
      republish: "Reactivate",
      export: "Export list to Excel",
      upgrade_to_feature_7: "Upgrade to Featured 7 Days",
      upgrade_to_feature_28: "Upgrade to Featured 28 Days",
      extend: "Extend listing expiry",
    },
    goToTop: "Return to the top",
  },
  promptMessage: {
    schedule: { success: "View schedule manager" },
  },
  bulkActions: {
    popupModal: {
      success: {
        title: "Success listing{count, plural, =0 {} =1 {} other{s}}",
        subTitle: {
          [BULK_ACTIONS.delete]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you deleted.",
          [BULK_ACTIONS.duplicate]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you duplicated.",
          [BULK_ACTIONS.export]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you exported.",
          [BULK_ACTIONS.extend]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you extended.",
          [BULK_ACTIONS.offline]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you offlined.",
          [BULK_ACTIONS.reactivate]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you reactivated.",
          [BULK_ACTIONS.republish]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you reactivated.",
          [BULK_ACTIONS.readvertise]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you readvertised.",
          [BULK_ACTIONS.schedule]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you schedule readvertiesed.",
          [BULK_ACTIONS.upgrade_to_feature_7]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you upgraded.",
          [BULK_ACTIONS.upgrade_to_feature_28]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you upgraded.",
          [SINGLE_ACTIONS.upgrade]:
            "Here are your listing{count, plural, =0 {} =1 {} other{s}} that you upgraded.",
        },
      },
      failed: {
        title: {
          [BULK_ACTIONS.delete]:
            "Sorry, we couldn’t delete {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.duplicate]:
            "Sorry, we couldn’t duplicate {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.export]:
            "Sorry, we couldn’t export {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.extend]:
            "Sorry, we couldn’t extend {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.offline]:
            "Sorry, we couldn’t offline {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.reactivate]:
            "Sorry, we couldn’t reactivate {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.republish]:
            "Sorry, we couldn’t reactivate {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.readvertise]:
            "Sorry, we couldn’t readvertise {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.schedule]:
            "Sorry, we couldn’t schedule readvertise {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.upgrade_to_feature_7]:
            "Sorry, we couldn’t upgrade {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [BULK_ACTIONS.upgrade_to_feature_28]:
            "Sorry, we couldn’t upgrade {count, plural, =0 {this listing} =1 {this listing} other{these listings}}.",
          [OTHER_ACTIONS.view_degraded]:
            "The below listing{count, plural, =0 {} =1 {} other{s}} {count, plural, =0 {has} =1 {has} other{have}} been degraded.",
        },
        subTitle: {
          [OTHER_ACTIONS.view_degraded]:
            "There were some issues with your listing{count, plural, =0 {} =1 {} other {s}}. Please contact your Account Manager to find out more.",
          default:
            "Please check that your listing{count, plural, =0 {} =1 {} other {s}} has all the content required and try again.",
        },
      },
      cancel: "Close",
      dismiss: "Dismiss",
    },
    title: {
      readvertise: "Select listings to readvertise",
      schedule: "Select listings to schedule readvertisement",
      offline: "Select listings to take offline",
      delete: "Select listings to delete",
      reactivate: "Select listings to reactivate",
      republish: "Select listings to reactivate",
      export: "Select listings to export to Excel",
    },
    selected: "<strong>{count}</strong> selected",
    adBalance: "Balance: <strong>{count} Ad credits</strong>",
    listingBalance: "Balance: <strong>{count} Listings</strong>",
    offline: {
      continueText: "Continue Offline",
    },
    delete: {
      continueText: "Continue Delete",
    },
    reactivate: {
      continueText: "Continue Reactivate",
      confirmModal: {
        confirmText: "Confirm Reactivate",
      },
    },
    republish: {
      continueText: "Continue Reactivate",
    },
    readvertise: {
      continueText: "Continue Readvertisement",
      success:
        "{listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} are now readvertised.",
      fail: "{errorCount} of your listing{errorCount, plural, =0 {} =1 {} other{s}} failed to readvertised.",
    },
    schedule: {
      continueText: "Continue Schedule Re-ad",
      success:
        "{listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} readvertisement schedule set.",
      fail: "Sorry. An unexpected error has occurred. Please try again later.",
    },
    export: {
      continueText: "Continue",
      downloadingMessage: "Downloading, please wait...",
    },
    upgrade_to_feature_7: {
      continueText: "Continue upgrade",
      success:
        "{listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} {listingCount, plural, =0 {has} =1 {has} other{have}} been upgraded.",
      fail: "{errorCount} listing{errorCount, plural, =0 {} =1 {} other{s}} failed to upgrade.",
    },
    upgrade_to_feature_28: {
      continueText: "Continue upgrade",
      success:
        "{listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} {listingCount, plural, =0 {has} =1 {has} other{have}} been upgraded.",
      fail: "{errorCount} listing{errorCount, plural, =0 {} =1 {} other{s}} failed to upgrade.",
    },
    extend: {
      continueText: "Continue Extend listing expiry",
      success:
        "{listingCount} listing{listingCount, plural, =0 {} =1 {} other{s}} expiry date has been extended.",
      fail: "{errorCount} of your listing{errorCount, plural, =0 {} =1 {} other{s}} listing expiry date has failed.",
    },
  },
  locationUpdate: {
    alert: {
      message:
        "The accuracy of our location data has improved. We encourage you to update your listing(s) location to boost prominence. Existing listing(s) won't be affected, but updates are highly recommended when extending listing expiry.",
    },
    toggle: {
      label: "View all to be updated location",
    },
    reactivateFromExpired: {
      title: "There was a problem reactivating this listing",
      content:
        "The location information needs to be updated first, then please try reactivating again.",
      btnCancel: "Cancel",
      btnOk: "Edit now",
    },
    extendListing: {
      title: "There was a problem extending this listing",
      content:
        "The location information needs to be updated first, then please try extending again.",
      btnCancel: "Cancel",
      btnOk: "Edit now",
    },
    upgradeListing: {
      title: "There was a problem upgrading this listing",
      content:
        "The location information needs to be updated first, then please try upgrading again.",
      btnCancel: "Cancel",
      btnOk: "Edit now",
    },
    copyListing: {
      title: "There was a problem copying this listing",
      content:
        "The location information needs to be updated first, then please try copying again.",
      btnCancel: "Cancel",
      btnOk: "Edit now",
    },
    selectAll: {
      title: "There was a problem {action} these listings",
      content:
        "The location information needs to be updated first, then please try {action} again.",
      btnCancel: "Cancel",
      btnOk: "OK",
    },
  },
});
